import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { navigateTo } from "gatsby-link"

import "../components/form.scss"

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export default class ContactPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state,
      }),
    })
      .then(() => navigateTo(form.getAttribute("action")))
      .catch(error => alert(error))
  }

  render() {
    return (
      <Layout>
        <div className="central__column__mini">
          <SEO
            title="Contact"
            keywords={[`Daisy`, `Godfrey`, `Nottingham`, `Singer`]}
          />
          <h2>
            Hi, if there’s something you’d like to get in touch with, drop me a
            message below and I will get back to you as soon as possible
          </h2>
          <form
            name="contact"
            method="post"
            action="/thanks/"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={this.handleSubmit}
          >
            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
            <input type="hidden" name="form-name" value="contact" />
            <div hidden>
              <label>
                Don’t fill this out:{" "}
                <input name="bot-field" onChange={this.handleChange} />
              </label>
            </div>

            {/* Client Name */}
            <label className="form__label" htmlFor="name">
              Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="form__input"
              placeholder="Your name"
              onChange={this.handleChange}
            />

            {/* Client Number */}
            <label className="form__label" htmlFor="number">
              Number
            </label>
            <input
              type="telephone"
              name="number"
              id="number"
              className="form__input"
              placeholder="A phone number so we can get in touch"
              onChange={this.handleChange}
            />

            {/* Client Email */}
            <label className="form__label" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              className="form__input"
              placeholder="Your email address"
              onChange={this.handleChange}
            />

            {/* Client Message */}
            <label className="form__label" htmlFor="message">
              Message
            </label>
            <textarea
              name="message"
              id="message"
              className="form__textarea"
              placeholder="Enter some more details"
              onChange={this.handleChange}
            />

            {/* Form submit button */}
            <input
              type="submit"
              value="Send Message"
              className="form__button"
            />
          </form>
        </div>
      </Layout>
    )
  }
}
